import { useDrag, useDrop, DragLayerMonitor } from "react-dnd";
import { useRef } from "react";
import { DragableCardProps } from "types";
import AttributeCard from "ui/atoms/AttributeCard";

function DragableAttributeCard({
  image,
  name,
  totalTraits,
  onClick,
  index,
  moveCard,
  styles,
}: DragableCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  // @ts-ignore
  const [{ handlerId }, drop] = useDrop({
    accept: "card",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    // @ts-ignore
    hover(item: DragableCardProps) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      return { id: index, index };
    },
    collect: (monitor: DragLayerMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.5 : 1;
  const zIndex = isDragging ? 2 : 1;

  drag(drop(ref));
  return (
    <div
      ref={ref}
      data-handler-id={handlerId}
      style={{ opacity, zIndex, ...styles }}
    >
      <AttributeCard
        name={name}
        image={image}
        totalTraits={totalTraits}
        onClick={onClick}
      />
    </div>
  );
}

export default DragableAttributeCard;
